export interface AnalysisFile {
    companyName?: string,
    creationTimestamp: string,
    fileType: AnalysisFileType,
    fileName: string,
    downloadUrl: string
}

export enum AnalysisFileType {
    UpcomingBonusRewardsAnalysisFile = "UpcomingBonusRewardsAnalysisFile",
    NewEmployeesAnalysisFile = "NewEmployeesAnalysisFile",
    BoughtVouchersAnalysisFile = "BoughtVouchersAnalysisFile",
    DirectPayoutAnalysisFile = "DirectPayoutAnalysisFile",
    CompanyPensionAnalysisFile = "CompanyPensionAnalysisFile",
}
